import * as React from "react";
import { useCurrentUserPrincipal } from "@/services/UserServices/UserService";
import { Button, Image } from "@fluentui/react-components";
import styles from "./Login.module.scss";
import { useTitle } from "@/hooks/UseTitle";
export interface ILoginProps {}

export function Login(props: ILoginProps) {
	const up = useCurrentUserPrincipal();
	useTitle("Login");
	React.useEffect(() => {
		if (!up.isLoading && !up.data?.clientPrincipal) window.location.href = "/login";
	}, [up]);
	return (
		<div className={styles.login}>
			{/* <div className={styles.headerImage}>
				<Image fit="contain" src={`${process.env.PUBLIC_URL}/login-screen.png`}></Image>
			</div>
			<div className={styles.body}>
				<Button href="/login" onClick={() => up.mutate()}>
					Sign In
				</Button>
			</div> */}
		</div>
	);
}
